import { jsx as s } from "react/jsx-runtime";
import { c as d } from "../../index-C3-ZVs5E.js";
import '../../assets/Divider.css';const r = "_divider_1hdc3_2", e = {
  divider: r
}, t = ({ className: i }) => /* @__PURE__ */ s("div", { className: d(e.divider, i) });
export {
  t as Divider
};
